"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.weakRandomChars = exports.getCharsetForHumans = exports.createUid = exports.uuidv4 = void 0;
const nanoid_1 = require("nanoid");
var uuid_1 = require("uuid");
Object.defineProperty(exports, "uuidv4", { enumerable: true, get: function () { return uuid_1.v4; } });
const _nanoidByCharLength = {};
const charsetForHumans = 'acdefghjkmnpqrtuvwxyz234679';
/**
 * Generates a random string of the specified length. Default is 16 characters. It uses a charset that omits potentially
 *  confusing characters. For example, a person might mistake the letter O for the number 0 when displayed in many common
 *  font styles.
 *
 * This CharsetForHumans uses 27 characters. Each additional character adds the equiv of ~ 4.75 bits.
 *  The default of 16 chars is equiv to just over 76 bits, just under 8E22 possibilities, log2(27) * 16.
 * In comparison, 16 random hex characters (64 bits) offers 1.8E19 possibilities. The closest to that would be using either a length
 *  of 14, exceeding it (27^14 ~= 1E20) or falling short with a length of 13 (for 4E18 possibilities.)
 *
 * @param length Number of characters in the generated uid.
 * @returns {*}
 */
function createUid(length = 16) {
    let nanoidFn = _nanoidByCharLength[length];
    if (!nanoidFn) {
        nanoidFn = _nanoidByCharLength[length] = nanoid_1.customAlphabet(charsetForHumans, length);
    }
    return nanoidFn();
}
exports.createUid = createUid;
function getCharsetForHumans() {
    return charsetForHumans.slice(0);
}
exports.getCharsetForHumans = getCharsetForHumans;
function weakRandomChars() {
    // todo: specify length; maybe option to use charsetForHumans
    return Math.random().toString(36).slice(2);
}
exports.weakRandomChars = weakRandomChars;
//# sourceMappingURL=uid-util.js.map